import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getTeamBudgets = ({ churchId, teamId, queries }) => {
  const queryBuilder = new QueryBuilder();

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.sort) {
    queryBuilder.sort(queries.sort);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/team-budgets/${teamId}${queryString}`
  );
};

export const useTeamBudgets = ({
  churchId,
  teamId,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["team-budgets", churchId, teamId, JSON.stringify(queries)],
    queryFn: () => getTeamBudgets({ churchId, teamId, queries })
  });
};
